import { useOrderETARange } from '@/features/shop/services/OrderEngagement/hooks'
import { screenSizes } from '@shipt/design-system-themes'
import { formatTimeWindow } from '@/features/shared/utils/formatter'
import { Headline } from '@shipt/design-system-typography'
import styled from 'styled-components'
import { type OrderStatus } from '@/features/shop/services/Orders/types'
import { formatTimeslot } from '@/features/shared/utils/deliveryWindows'

export const OrderTimelineMessage = ({
  status,
  isPickup,
  timeWindow,
  orderId,
  isEarlyDelivery,
}: {
  status: OrderStatus
  isPickup: boolean
  timeWindow: string
  orderId: number
  isEarlyDelivery: boolean
}) => {
  const { shopperEta, hasErrorOrFetching, isRealTimeETA } = useOrderETARange({
    orderId,
    orderStatus: status,
    isPickup,
  })

  const { day, end, start } = formatTimeWindow(timeWindow)
  let deliveryTime

  if (isRealTimeETA && !hasErrorOrFetching) {
    deliveryTime = shopperEta
  } else if (isEarlyDelivery) {
    deliveryTime = `Your next order arrives ${day}, by ${end}`
  } else {
    deliveryTime = `Your next order arrives by ${formatTimeslot(start, end)}`
  }

  return <OrderTimeline size="md">{deliveryTime}</OrderTimeline>
}

const OrderTimeline = styled(Headline)`
  color: ${({ theme }) => theme.white};

  @media ${screenSizes.tablet} {
    padding-right: 1rem;
    border-right: 1px solid;
  }
`
